stimulusApp.register(
  "cruise-cabins",
  class extends Stimulus.Controller {
    static targets = ["modal"]

    disconnect() {
      this.#unlock()
    }

    openRow(event) {
      if (event.target.closest("a, button")) return

      event.currentTarget.querySelector(".cruise-cabins--thumb").click()
    }

    ignoreRepeatClick(event) {
      if (event.currentTarget.hasAttribute("disabled")) event.preventDefault()
    }

    open(event) {
      const modal = this.modalTargets.find(
        (candidate) => candidate.id === event.params.cabin,
      )
      if (!modal) return

      this.#hideModals()
      this.opener = event.currentTarget
      modal.hidden = false
      document.body.classList.add("noscroll")
      modal.querySelector(".cruise-cabin-modal--close").focus()
    }

    close() {
      this.#dismiss()
    }

    backdropClose() {
      this.#dismiss()
    }

    trapFocus(event) {
      const modal = this.modalTargets.find((candidate) => !candidate.hidden)
      if (!modal) return

      const stops = [...modal.querySelectorAll("a[href], button")].filter(
        (element) => !element.disabled && element.getClientRects().length > 0,
      )
      const edge = event.shiftKey ? stops[0] : stops[stops.length - 1]
      if (document.activeElement !== edge) return

      event.preventDefault()
      ;(event.shiftKey ? stops[stops.length - 1] : stops[0]).focus()
    }

    #dismiss() {
      if (this.modalTargets.every((modal) => modal.hidden)) return

      this.#hideModals()
      this.#unlock()
      this.opener?.focus()
    }

    #hideModals() {
      this.modalTargets.forEach((modal) => (modal.hidden = true))
    }

    #unlock() {
      document.body.classList.remove("noscroll")
    }
  },
)
